const withDefaultThumbnailUrl = (superClass) => class extends superClass {
  get url() {
    return this.defaultThumbnailUrl;
  }
};

export default withDefaultThumbnailUrl;
